export const FETCH_TOOLBOX = '@@material/fetch-toolbox';
export const FETCH_TOOLBOX_SUCCESS = '@@material/fetch-toolbox-success';
export const FETCH_TOOLBOX_FAILURE = '@@material/fetch-toolbox-failure';
export const FETCH_TOOLBOX_DETAILS = '@@material/fetch-toolbox-details';
export const FETCH_TOOLBOX_DETAILS_SUCCESS = '@@material/fetch-toolbox-details-success';
export const FETCH_TOOLBOX_DETAILS_FAILURE = '@@material/fetch-toolbox-details-failure';
//
export const FETCH_TOOLBOXHOME = '@@material/fetch-toolboxhome';
export const FETCH_TOOLBOXHOME_SUCCESS = '@@material/fetch-toolboxhome-success';
export const FETCH_TOOLBOXHOME_FAILURE = '@@material/fetch-toolboxhome-failure';
